import Param from './param';
import Util from './module/libs/util';
import accordionManager from './module/libs/accordion';
import sliderManager from './module/libs/slider';
import effectManager from './module/effect';
import globalNavi from './module/global/globalNavi';
import smoothScrollManager from './module/scroll/scrollManager';
import MouseManager from './module/mouse/mouseManager';
import tabManager from './module/tab/manager';
import kvManager from './module/kv/manager';
import modalManager from './module/modal/manager';
import topManager from './page/top';
import conceptManager from './page/concept';
import shoplist from './page/shoplist';
import teshigotoManager from './page/teshigoto';
import technologyManager from './page/technology';
import aboutmadeinjapanManager from './page/about_madeinjapan';
import faqManager from './page/faq';
import faqPreManager from './page/faqPre';
import supportManager from './page/support';
import safeManager from './page/safe';
import companyManager from './page/company';
import recruitManager from './page/recruit';
import whatisManager from './page/whatis';
import howtoManager from './page/howto';
import newcolorManager from './page/new_color';
import kitchenitemsManager from './page/kitchenitems';
import madeinjapanManager from './page/madeinjapan';
import awardsManager from './page/awards';
import specManager from './page/spec';
import catalogManager from './page/catalog';
import specialInterviewManager from './page/special_interview';
import ownersvoiceManager from './page/ownersvoice';
import missionManager from './page/mission';
import fryingpanManager from './page/fryingpan';
import fryingpanConceptManager from './page/fryingpan/fryingpanConcept';
import fryingpanHeaderManager from './page/fryingpan/header';
import fryingpanTechnologyManager from './page/fryingpan/fryingpanTechnology';
import fryingpanFeaturesManager from './page/fryingpan/fryingpanFeatures';
import fryingpanMadeinjapanManager from './page/fryingpan/fryingpanMadeinjapan';
import fryingpanCareManager from './page/fryingpan/fryingpanCare';
import fryingpanSpecManager from './page/fryingpan/fryingpanSpec';
import spTurnDevice from './module/global/spTurnDevice';

// アプリキャンペーンによる追加分
// import appCampaignManager from './page/top_app_campaign';
// import webglManager from './module/webgl/manager';
// import animeManager from './module/anime/manager';
// import crackerManager from './module/cracker/manager';

const param = new Param();
const util = new Util();
let accordion;
let slider;
let effect;
let gNavi;
let scroll;
let mouse;
let tab;
let kv;
let modal;
let toppage;
let concept;
let shop;
let teshigoto;
let technology;
let aboutMadeinjapan;
let faq;
let support;
let safe;
let company;
let recruit;
let whatis;
let howto;
let newcolor;
let kitchenitems;
let awards;
let spec;
let catalog;
let mission;
let specialInterview;
let ownersvoice;
let madeinjapan;
let fryingpan;
let fryingpanConcept;
let fryingpanHeader;
let fryingpanFeatures;
let fryingpanTechnology;
let fryingpanMadeinjapan;
let fryingpanCare;
let fryingpanSpec;

// アプリキャンペーンによる追加分
// let cracker;
// let anime;
// let webgl;
// let appCampaign;

let turnDevice = new spTurnDevice(Useragnt.mobile || Useragnt.tablet? "sp":"pc");

const stats = new Stats();
stats.showPanel( 0 );
//document.body.appendChild( stats.dom );

let pageID = document.body.id;
let fpsRate = 0;
let executionType = "landing"; /* 実行タイミングの制御用 */
let _w = 0;
let _h = 0;
let _x = 0;
let _y = 0;
let _dir = '';
let _delta = '';
let _scrollFlg = false;

//element
let _header = document.getElementById('l-header');
let _root = document.getElementById('l-root');
let loaded = false;

const storageKeyScrollY = `scrollY:${location.pathname}`

/* ---------------------------------------------------

  -- render

 --------------------------------------------------- */

let render = function () {

    if(!requestAnimationFrame){
        setTimeout(() => {
            render;
        },1000/60);
    }else{
        requestAnimationFrame(render);
    }

    fpsRate = util.updateTimeRatio();

    //stats.begin();

    if(pageID === "top") {
        slider.render();
    }
    if(pageID === "concept"){
        if(concept.ytFlg)
            concept.render();
    }
    if(pageID === "madeinjapan"){
        if(aboutMadeinjapan.ytFlg)
            aboutMadeinjapan.render();
    }

    // アプリキャンペーンによる追加分　ここから
    // if(pageID === 'top'){
    //     if(webgl) webgl.render(scroll);
    //     if(anime) anime.check(scroll.nowInc); anime.render();
    // }
    // アプリキャンペーンによる追加分 ここまで


    if(!scroll.status.comp&&gNavi.status.now!=="open")
    scroll.move();

    _dir = scroll.dir;

    if (fryingpan && fryingpan.isReady) {
        fryingpan.render()
    }

    if (fryingpanConcept && fryingpanConcept.isReady) {
        fryingpanConcept.render()
    }

    if (fryingpanMadeinjapan && fryingpanMadeinjapan.isReady) {
        fryingpanMadeinjapan.render()
    }

    if (fryingpanTechnology && fryingpanTechnology.isReady) {
        fryingpanTechnology.render()
    }

    if (fryingpanFeatures && fryingpanFeatures.isReady) {
        fryingpanFeatures.render()
    }

    if (fryingpanCare && fryingpanCare.isReady) {
        fryingpanCare.render()
    }

    if (fryingpanSpec && fryingpanSpec.isReady) {
        fryingpanSpec.render()
    }

    //stats.end();

}


/* ---------------------------------------------------

  -- common

 --------------------------------------------------- */


let common = function (type) {
    switch(pageID){
        case "faq":
            new faqPreManager();
            break;
    }

    effect = new effectManager();
    gNavi = new globalNavi(pageID,param);
    accordion = new accordionManager(param);
    mouse = new MouseManager();
    scroll = new smoothScrollManager(param,effect,pageID);
    scroll.status.comp = false;

    if(document.getElementsByClassName('js__tab').length > 0){
        tab = new tabManager();
        tab.init();
    }

    if(document.getElementsByClassName('js__slider').length > 0){
        slider = new sliderManager(pageID,scroll);
        slider.set();
    }

    if(document.getElementById('p-kv')){
        kv = new kvManager(pageID,param);
        kv.init(pageID);
    }

    switch(pageID){
        case "top":
            param.type = 'full';
            // アプリキャンペーンによる追加分　ここから
            // cracker = new crackerManager(param);
            // anime = new animeManager();
            // webgl = new webglManager();
            // appCampaign = new appCampaignManager(scroll,effect,param,webgl,anime,cracker);
            // cracker.init();
            // webgl.init();
            // appCampaign.init();
            // アプリキャンペーンによる追加分 ここまで
            toppage = new topManager();
        break;
        case "concept":
            concept = new conceptManager();
            break;
        case "teshigoto":
            teshigoto = new teshigotoManager();
            break;
        case "about_technology":
            technology = new technologyManager();
            break;
        case "madeinjapan":
            aboutMadeinjapan = new aboutmadeinjapanManager();
            break;
        case "shoplist":
            shop = new shoplist();
            break;
        case "faq":
            faq = new faqManager();
            break;
        case "recruit":
            recruit = new recruitManager();
            break;
        case "whatis":
            whatis = new whatisManager();
            break;
        case "howto":
            howto = new howtoManager();
            break;
        case "new_color":
            newcolor = new newcolorManager();
            break;
        case "company":
            company = new companyManager();
            break;
        case "support":
            support = new supportManager();
            break;
        case "safe":
            safe = new safeManager();
            break;
        case "magnettrivet":
        case "hk_and_ph":
        case "apron_and_cloth":
            kitchenitems = new kitchenitemsManager(pageID,param);
            break;
        case "made_in_japan":
        case "made_in_japan01":
        case "made_in_japan02":
        case "made_in_japan03":
        case "made_in_japan04":
        case "made_in_japan05":
            madeinjapan = new madeinjapanManager();
            break;
        case "cm_gallery":
            whatis = new whatisManager();
            break;
        case "awards":
            awards = new awardsManager(scroll);
            break;
        case "spec":
            spec = new specManager();
            break;
        case "catalog":
            catalog = new catalogManager();
            break;
        case "mission":
            mission = new missionManager(param);
            break;
        case "special_interview":
            specialInterview = new specialInterviewManager(param);
            break;
        case "ownervoice01":
        case "ownervoice02":
        case "ownervoice03":
            ownersvoice = new ownersvoiceManager(param);
            break;
        case "fryingpan":
            fryingpan = new fryingpanManager(param, scroll);
            break;
        case "fryingpan_concept":
            fryingpanConcept = new fryingpanConceptManager(param, scroll);
            break;
        case "fryingpan_technology":
            fryingpanTechnology = new fryingpanTechnologyManager(param, scroll);
            break;
        case "fryingpan_features":
            fryingpanFeatures = new fryingpanFeaturesManager(param, scroll);
            break;
        case "fryingpan_madeinjapan":
            fryingpanMadeinjapan = new fryingpanMadeinjapanManager(param, scroll);
            break;
        case "fryingpan_care":
            fryingpanCare = new fryingpanCareManager(param, scroll);
            break;
        case "fryingpan_spec":
            fryingpanSpec = new fryingpanSpecManager(param, scroll);
            break;
    }

    if(document.querySelector('.fryingpan_header')) {
        fryingpanHeader = new fryingpanHeaderManager(param, scroll)
    }

    if(document.getElementsByClassName('js__modal').length > 0){
        modal = new modalManager();
    }

    if(type==="landing"){
        TweenMax.set(_root,{opacity:1});
    }


    scroll.init();
    pageManager(pageID);
    resize();

    let scrollY = window.sessionStorage.getItem(storageKeyScrollY);
    if (
        scrollY &&
        window.performance && (performance.navigation.type === 1 || performance.navigation.type === 2)
    ) {
        scrollY = Number(scrollY);
        gNavi.update(scrollY);
        scroll.updateNoAnimate(scrollY);
    }

    render();

    //event tracking
    if(document.getElementsByClassName('js__ga-click').length > 0){
        let _ga = document.querySelectorAll('.js__ga-click');
        let _category = [];
        let _label = [];
        for(let i=0; document.getElementsByClassName('js__ga-click').length>i; i++){
            _category[i] = _ga[i].getAttribute('data-gacategory');
            _label[i] = _ga[i].getAttribute('data-galabel');
            _ga[i].onclick = ()=> {
                gtag('event', 'click', {
                    'event_category': ''+_category[i]+'',
                    'event_label': ''+_label[i]+'',
                    'value': '1'
                });
            };
        }
    }


}

let pageManager = function(type){

    switch(pageID){
        case "top":
            setTimeout(() => {
                toppage.init();
            },1e3);
        break;
        case "concept":
            setTimeout(() => {
                concept.init();
            },1e3);
        break;
        case "teshigoto":
            setTimeout(() => {
                teshigoto.init();
            },1e3);
            break;
        case "about_technology":
            setTimeout(() => {
                technology.init();
            },1e3);
            break;
        case "madeinjapan":
            setTimeout(() => {
                aboutMadeinjapan.init();
            },1e3);
            break;
        case "shoplist":
            setTimeout(() => {
                shop.init();
            },1e3);
            break;
        case "faq":
            setTimeout(() => {
                faq.init();
            },1e3);
            break;
        case "recruit":
            setTimeout(() => {
                accordion.init();
                // recruit.init();
            },1e3);
            break;
        case "whatis":
            setTimeout(() => {
                whatis.init();
            },1e3);
            break;
        case "howto":
            setTimeout(() => {
                howto.init();
            },1e3);
            break;
        case "new_color":
            setTimeout(() => {
                newcolor.init();
            },1e3);
            break;
        case "company":
            setTimeout(() => {
                company.init();
            },1e3);
            break;
        case "support":
            if(param.userAgent = "sp"){
                setTimeout(() => {
                    support.init();
                },1e3);
            }
            break;
        case "safe":
            if(param.userAgent = "sp"){
                setTimeout(() => {
                    safe.init();
                },1e3);
            }
            break;
        case "magnettrivet":
        case "hk_and_ph":
        case "apron_and_cloth":
            setTimeout(() => {
                kitchenitems.init();
            },1e3);
            break;
        case "made_in_japan":
        case "made_in_japan01":
        case "made_in_japan02":
        case "made_in_japan03":
        case "made_in_japan04":
        case "made_in_japan05":
            madeinjapan.init();
            setTimeout(() => {
                madeinjapan.splash();
            },1e3);
            break;
        case "cm_gallery":
            setTimeout(() => {
                whatis.init();
            },1e3);
            break;
        case "awards":
            setTimeout(() => {
                awards.init();
            },1e3);
            break;
        case "spec":
            setTimeout(() => {
                spec.init();
            },1e3);
            break;
        case "catalog":
            setTimeout(() => {
                catalog.init();
                catalog.splash();
            },1e3);
            break;
        case "mission":
            setTimeout(() => {
                mission.init();
                mission.splash();
            },1e3);
            break;
        case "special_interview":
            specialInterview.init();
            if(param.userAgent === "pc"){
                setTimeout(() => {
                    specialInterview.splash();
                },1e3);
            }
            break;
        case "ownervoice01":
        case "ownervoice02":
        case "ownervoice03":
            ownersvoice.init();
            ownersvoice.splash();
            break;
        case "about_technology":
            setTimeout(() => {
                whatis.init();
            },1e3);
            break;
        case "fryingpan":
            setTimeout(() => {
                fryingpan.init();
            },1e3);
            break;
        case "fryingpan_concept":
            setTimeout(() => {
                fryingpanConcept.init();
            },1e3);
            break;
        case "fryingpan_technology":
            setTimeout(() => {
                fryingpanTechnology.init();
            },1e3);
            break;
        case "fryingpan_features":
            setTimeout(() => {
                fryingpanFeatures.init();
            },1e3);
            break;
        case "fryingpan_madeinjapan":
            setTimeout(() => {
                fryingpanMadeinjapan.init();
            },1e3);
            break;
        case "fryingpan_care":
            setTimeout(() => {
                fryingpanCare.init();
            },1e3);
            break;
        case "fryingpan_spec":
            setTimeout(() => {
                fryingpanSpec.init();
            },1e3);
            break;
    }


    // fryingpan: ヘッダー処理追加
    if(document.querySelector('.fryingpan_header')) {
        setTimeout(() => {
            fryingpanHeader.init();
        },1e3);
    }

    if(document.getElementsByClassName('js__modal').length > 0){
        setTimeout(() => {
            modal.init();
        },'1e3');
    }

    setTimeout(() => {
        loaded = true;
    },'1e3');

        if(location.hash){
            let _position = document.querySelector(location.hash).getBoundingClientRect().top;
            setTimeout(() => {
                TweenLite.to(window, 0 ,{scrollTo:{y: _position,autoKill:false}});
                loaded = true;
            },'2e3');
        }


}

let resize = function () {

    param.displayType = ( window.innerWidth>param.breakpoint )?"pc":"sp";

    _w = window.innerWidth;
    _h = window.innerHeight;

    gNavi.resize(_w,_h);

    accordion.resize(_w,_h);

    scroll.resize(_w,_h);

    if(document.getElementById('p-kv')){
        kv.resize(_w);
    }

    //if(appCampaign) appCampaign.resize(_w,_h);

    if(document.getElementsByClassName('js__slider').length > 0){
        slider.resize(_w,_h);
    }

    if(pageID === 'catalog'){
        setTimeout(() => {
            catalog.resize();
        },0.5e3);
    }

    if (Useragnt.mobile || Useragnt.tablet) turnDevice.resize();

}


/* ---------------------------------------------------

  -- load

 --------------------------------------------------- */

window.addEventListener('DOMContentLoaded', function() {
    //TweenLite.to(window, 0, {scrollTo:0,autoKill:false});
    common("landing");
});

// 中国語の場合は中国サイトへリダイレクト
judgeCn();
function judgeCn() {
    const language = (window.navigator.languages && window.navigator.languages[0]) || window.navigator.language || window.navigator.userLanguage || window.navigator.browserLanguage;
    //  const languages = window.navigator.languages || [ window.navigator.language || window.navigator.userLanguage || window.navigator.browserLanguage ];
    const CnURL = 'https://www.vermicular.cn/';
    const chinese = 'zh-CN';
    // console.log(language);
    if(language === chinese && sessionStorage.getItem('access') !== 'true') {
        // アクセスが初めての場合はアイテムをセット
        sessionStorage.setItem('access', true);
        // リダイレクト処理
        location.href = CnURL;
    };
}

/* ---------------------------------------------------

  -- event

 --------------------------------------------------- */

/* scroll */
window.onscroll = function (e) {
    if(!loaded) return;

    scroll.status.start = true;

    if(gNavi.status.now==="open"){
        e.preventDefault();
        return;
    }else{
        _y = window.pageYOffset || document.documentElement.scrollTop;
        gNavi.update(_y);
        scroll.update(_y,"");
    }

    gNavi.scroll();

    if (fryingpan && fryingpan.isReady) {
        fryingpan.onScroll(window.pageYOffset || document.documentElement.scrollTop)
    }
    if (fryingpanTechnology && fryingpanTechnology.isReady) {
        fryingpanTechnology.onScroll(window.pageYOffset || document.documentElement.scrollTop)
    }

    if(_scrollFlg) return;

    _scrollFlg = true;
    _w = window.innerWidth;
    _h = window.innerHeight;
    scroll.resize(_w,_h);

};

let scrollEvent = function () {

    if(!loaded) return;

    if(_dir === 'prev'){
        _y = window.pageYOffset || document.documentElement.scrollTop;
    }

}

/* wheel */
var MOUSE_WHEEL_EVENT = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
document[MOUSE_WHEEL_EVENT] = function (e) {

    _delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail);

    if (_delta < 0){
        _dir = 'next';
        scrollEvent();
    }else if (_delta > 0){
        _dir = 'prev';
        scrollEvent();
    }

};

/* [ SMP Tablet用 ]
 ------------------------------------*/

let touchInc = {
    x : 0,
    y : 0,
    pos : 0,
}


document.addEventListener("touchstart",(e)=> {
    touchInc.x = e.touches[0].pageX;
    touchInc.y = e.touches[0].pageY;
});
document.addEventListener('touchmove',(e)=> {
    if(gNavi.status.now==="open"){
        //e.preventDefault(); // スマホのスクロールを止める
    }
}, {passive: false});
document.addEventListener("touchend",(e)=> {

    let nowY = e.changedTouches[0].pageY;

    if (touchInc.y>nowY&&touchInc.y - nowY >50) {
        _dir = 'next';
        scrollEvent();
    }else if(touchInc.y<nowY&&nowY-touchInc.y >50){
        _dir = 'prev';
        scrollEvent();
    }

});

/* [ keyboard 用 ]
 ------------------------------------*/

document.addEventListener('keyup',function(e){

    if(e.keyCode == 40 || e.keyCode == 34 ){

        _dir = 'next';
        scrollEvent();

    }else if(e.keyCode == 38 || e.keyCode == 33){

        _dir = 'prev';
        scrollEvent();

    }

});

/* mouse event */
if(Useragnt.pc){
    window.addEventListener("mousemove",function (e) {
        if(!loaded) return;
        _x = e.clientX;
        _y = e.clientY;
        //mouse.update(_x,_y);
    });
}

window.addEventListener('resize', resize, false);
window.addEventListener('onorientationchange', resize, false);

window.addEventListener('beforeunload', function(e) {
    window.sessionStorage.setItem(storageKeyScrollY, `${window.pageYOffset || document.documentElement.scrollTop}`);
}, false);
